import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `EntradaAlmacen/imprimirEntradaAlmacen`, method: 'POST', body: list, token: token})
}